export class UnsubscribeApiPaths {
    constructor(private readonly api: string) {}
    unsubscribe = (subscriptionId: string) => `${this.api}/${subscriptionId}`;
}
